import { useAxios } from "utils/axiosHook";

//学校内の生徒たちの出席状況を取得
const useGradeSections = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {},
    { manual: true }
  );

  const getGradeSections = () => {
    return api({
      url: `/grade_sections`,
      method: "GET",
    });
  };

  return { data, loading, error, getGradeSections };
};

export { useGradeSections };
